import AddAlt16 from '@carbon/icons-react/es/add--alt/16';
import { Tooltip } from 'antd';
import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { AddButton } from 'components/organisms/projects/project-sidebar/spaces-menu/styles';
import { PermissionRuleName } from 'constant';
import { ActionMenu, MenuTitleContainer } from '../common';
import { SpaceT } from '../use-sidebar-data';
import { GroupTitle } from './title-container.styles';

const StyledActionMenu = styled(ActionMenu)`
  display: flex;
`;

type TitleContainerTypes = {
  editMode: ReactNode;
  tooltipTitle: JSX.Element | string;
  space: SpaceT;
  editing: boolean;
  handleAdd: () => void;
  testId: string;
  isLoading?: boolean;
  moreActions?: ReactNode;
};
export const TitleContainer: FC<TitleContainerTypes> = ({
  editMode,
  tooltipTitle,
  space,
  editing,
  moreActions,
  handleAdd,
  isLoading,
  testId,
}: TitleContainerTypes) => {
  const handleDocAdd = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    handleAdd();
  };
  const { spaceName } = space;

  const arrOfWords = spaceName.trim().split(' ');
  const lastWordCount = arrOfWords[arrOfWords.length - 1].length;

  return (
    <MenuTitleContainer data-cy={`space-name-group-${spaceName}`}>
      {editing ? (
        editMode
      ) : (
        <>
          <div data-cy={`space-${spaceName}`}>
            <GroupTitle
              suffixCount={lastWordCount > 8 ? 8 : lastWordCount}
              tooltip={<div>{spaceName}</div>}
              width="166px"
            >
              {spaceName}
            </GroupTitle>
          </div>
          <div>
            {!isLoading && (
              <StyledActionMenu className="more-actions">
                {moreActions}

                <Tooltip title={tooltipTitle}>
                  <AddButton
                    onClick={handleDocAdd}
                    data-test-id={testId}
                    disabled={isLoading}
                    icon={<AddAlt16 />}
                    className="add-button"
                    size="small"
                    type="text"
                    ruleName={
                      space.private
                        ? undefined
                        : PermissionRuleName.SpaceSharedDocumentCreateAction
                    }
                  />
                </Tooltip>
              </StyledActionMenu>
            )}
          </div>
        </>
      )}
    </MenuTitleContainer>
  );
};
